import React, { FC } from "react";
import { User } from "../../../models/user";
import CopyButton from "../../common/button/copyButton";

interface ProfileTitleProps {
  user: User;
}

const ProfileTitle: FC<ProfileTitleProps> = ({ user }) => {
  const handleCopyAddress = () => {
    navigator.clipboard.writeText(user.address);
  };

  const handleShareProfile = () => {
    navigator.clipboard.writeText(
      `${location.origin}/profile/${
        user.username ? user.username : user.address
      }`
    );
  };

  return (
    <div className="flex flex-col space-y-24">
      <div className="flex flex-col">
        <div className="display1 hidden md:block text-white">
          {user.name
            ? user.name
            : `${user.address.slice(0, 4)}...${user.address.slice(-4)}`}
        </div>
        <h1
          className="text-white md:hidden"
          style={{ wordBreak: "normal", overflowWrap: "anywhere" }}
        >
          {user.name
            ? user.name
            : `${user.address.slice(0, 4)}...${user.address.slice(-4)}`}
        </h1>
        {user.username && (
          <>
            <div
              className="hidden md:block display2 text-gradient"
              style={{ wordBreak: "normal", overflowWrap: "anywhere" }}
            >
              @{user.username}
            </div>
            <h2
              className="md:hidden text-gradient"
              style={{ wordBreak: "normal", overflowWrap: "anywhere" }}
            >
              @{user.username}
            </h2>
          </>
        )}
      </div>
      <div className="flex flex-row text-dark-white-64 space-x-24">
        <div className="text-white">
          <CopyButton onClick={handleShareProfile} prompt="Copied profile url">
            Share profile
          </CopyButton>
        </div>
        <div>
          <CopyButton
            onClick={handleCopyAddress}
            prompt="Copied Address"
          >{`${user.address.slice(0, 4)}...${user.address.slice(
            -4
          )}`}</CopyButton>
        </div>
      </div>
    </div>
  );
};

export default ProfileTitle;
